import { useMemo, useState } from 'react';
import { paginationDefaultValues } from './constants.js';
import { PaginationDefaultValue } from './types.js';
export const usePagination = (limit) => {
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(limit ? paginationDefaultValues[limit] : paginationDefaultValues[PaginationDefaultValue.LG]);
    return useMemo(() => ({
        page,
        setPage,
        perPage,
        setPerPage,
    }), [page, perPage]);
};
